import { Component, computed, input } from '@angular/core';
import { ImageMetadata } from 'app/shared/models/image-metadata.model';

@Component({
  selector: 'ez-header',
  imports: [],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  readonly organisationName = input<string>();
  readonly imageData = input.required<ImageMetadata>();

  readonly altText = computed(() => `Firmenlogo ${this.organisationName()}`);
  readonly imgSrc = computed(() => this.imageData().imgSrc);
  readonly imgWidth = computed(() => this.imageData().imgWidth);
  readonly imgHeight = computed(() => this.imageData().imgHeight);
}
